import { render, staticRenderFns } from "./RelatedBusinessesModal.vue?vue&type=template&id=66e7afdd&scoped=true&"
import script from "./RelatedBusinessesModal.vue?vue&type=script&lang=ts&"
export * from "./RelatedBusinessesModal.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedBusinessesModal.vue?vue&type=style&index=0&id=66e7afdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e7afdd",
  null
  
)

export default component.exports